define('views/blocks/FiltersView',['jquery', 'backbone', 'router', 'app',
        'TagCommander',
        'SubView',
        'template!blocks/filters'
    ],
    function ($, Backbone, router, app,
              TagCommander,
              SubView,
              filtersTemplate
    ) {

    var FiltersView = Backbone.View.extend(SubView).extend({
        events: {
            'click .btn-close': 'clickClose',
            'click .submit-filters': 'submitFilters'
        },
        className: 'modal-bottom',
        overlay: 'translucent',
        initialize: function () {
            var view = this,
                tags = app.getTags(),
                allergenGroups = app.getAllergenGroups();
            view.$el.html(filtersTemplate({
                tags: tags,
                allergenGroups: allergenGroups,
            }));
        },
        submitFilters:function(e){
            e.preventDefault();
            var view = this,
                tags = app.getTags(),
                allergenGroups = app.getAllergenGroups();
            //
            function filterCheckbox(filter){
                var checkbox = view.$('input[name='+filter.idAttribute+'-'+filter.id+']'),
                    checked = checkbox.is(':checked');
                filter.set('filterChecked',checked);
            }
            //
            tags.each(filterCheckbox);
            allergenGroups.each(filterCheckbox);
            TagCommander.eventGA(e.currentTarget,"Commander","Filter",TagCommander.getFilter());
            app.trigger('listingFilterChange');
            view.trigger('close', view);

        },
        clickClose: function (e) {
            e.preventDefault();
            this.trigger('close', this);
        }

    });

    return FiltersView;
});
